import { activePlan } from '@/features/plan/lib/active-plan'
import { planFraming } from '@/features/plan/lib/plan-framing'
import {
  ContentFormat,
  StartFlowType,
  type UserQuery,
} from '@/generated/graphql'
import { isOnboardingCompleted } from '../hooks/use-onboarding-status'

// Dev-only QA seam: `?planReveal` opens onboarding on any plan, completed or not.
function isForced(): boolean {
  if (!import.meta.env.DEV) return false
  try {
    return new URLSearchParams(window.location.search).has('planReveal')
  } catch {
    return false
  }
}

// Gated to the step arm on purpose — the control's baseline must not move mid-test.
export function owesOnboarding(
  me: UserQuery['me'],
  planId: string | undefined,
): boolean {
  if (!planId) return false
  if (isForced()) return true
  const completed = isOnboardingCompleted(me.id, planId)
  if (planFraming(me) !== 'step') return !completed
  const plan = me.availablePlans.find((p) => p.id === planId) ?? activePlan(me)
  // Non-journey formats keep the local flag as the trigger: the server sends them no verdict.
  if (plan?.contentFormat !== ContentFormat.Journey) return !completed
  // No verdict is a no: the server guarantees a step plan carries one. The local
  // flag can only veto, for users the server backfill has not reached.
  if (plan.startFlow?.type !== StartFlowType.Onboarding) return false
  return !completed
}
